import { DataState } from "Models/Common/DataState";
import { TaskTemplate } from "Models/Tasks/TaskTemplate";
import { Reducer } from "redux";
import { ActionTypes, TaskTemplateActions } from "./TaskTemplateActionTypes";
import { ITaskTemplateState, TaskTemplateState } from "./TaskTemplateState";

function setDateStringsToDate(taskTemplates: TaskTemplate[]) {
    for (const taskTemplate of taskTemplates) {
        for (const taskRecurrency of taskTemplate.taskRecurrencies) {
            taskRecurrency.fromDate = setDateStringToDate(taskRecurrency.fromDate);
            taskRecurrency.untilDate = setDateStringToDate(taskRecurrency.untilDate);
            taskRecurrency.executionDate = setDateStringToDate(taskRecurrency.executionDate);
        }
    }
}

function setDateStringToDate(date?: Date): Date | undefined {
    if (date) {
        const realDate = new Date(date);
        return new Date(Date.UTC(realDate.getFullYear(), realDate.getMonth(), realDate.getDate(), 0, 0, 0, 0));
    }

    return date;
}

export const initialState: ITaskTemplateState = new TaskTemplateState();
const reducer: Reducer<ITaskTemplateState> = (state: ITaskTemplateState = initialState, action: TaskTemplateActions) => {
    switch (action.type) {
        case ActionTypes.CLEAR_TEMPLATES:
            return { ...state, taskTemplates: [] };
        case ActionTypes.FILTER_UPDATED:
            return { ...state, currentFilter: action.filter, isLoading: true };
        case ActionTypes.PAGE_RETRIEVED:
            const taskTemplates = state.taskTemplates ? [...state.taskTemplates] : [];
            const newTemplates = action.page.items.filter(newTaskTemplate => taskTemplates.find(t => t.id === newTaskTemplate.id) === undefined);
            setDateStringsToDate(newTemplates);
            taskTemplates.push(...newTemplates);
            return { ...state, taskTemplates, totalTasks: action.page.totalItems, isLoading: false };
        case ActionTypes.TASK_TEMPLATE_STATE_CHANGED:
            return { ...state, detailTaskTemplateStates: { ...state.detailTaskTemplateStates, [action.taskTemplateId || -1]: action.newState } };
        case ActionTypes.TASK_TEMPLATE_RETRIEVED:
            setDateStringsToDate([action.taskTemplate]);
            return {
                ...state,
                detailTaskTemplates: { ...state.detailTaskTemplates, [action.taskTemplate.id!]: action.taskTemplate },
                detailTaskTemplateStates: { ...state.detailTaskTemplateStates, [action.taskTemplate.id!]: DataState.Done }
            };
        case ActionTypes.TASK_TEMPLATE_SAVED:
            setDateStringsToDate([action.taskTemplate]);
            return {
                ...state,
                taskTemplates: [],
                detailTaskTemplates: { ...state.detailTaskTemplates, [action.taskTemplate.id!]: action.taskTemplate },
                detailTaskTemplateStates: { ...state.detailTaskTemplateStates, [action.taskTemplate.id!]: DataState.Done }
            };
        case ActionTypes.TASK_TEMPLATE_DELETED:
            // Remove the template from the overview page
            if (state.taskTemplates) {
                const index = state.taskTemplates.findIndex(x => x.id === action.taskTemplateId);
                if (index >= 0) {
                    state.taskTemplates.splice(index, 1);
                }
            }

            // Remove the template from the template detail storage
            if (state.detailTaskTemplates && state.detailTaskTemplates[action.taskTemplateId]) {
                delete state.detailTaskTemplates[action.taskTemplateId];
            }

            return {
                ...state,
                detailTaskTemplateStates: { ...state.detailTaskTemplateStates, [action.taskTemplateId]: DataState.Deleted }
            };
        case ActionTypes.SHOW_VALIDATION_ERRORS:
            return { ...state, detailTaskTemplateValidationErrors: { ...state.detailTaskTemplateValidationErrors, [action.taskTemplateId || -1]: action.validationErrors } };
        case ActionTypes.CLEAR_VALIDATION_ERRORS:
            return { ...state, detailTaskTemplateValidationErrors: { ...state.detailTaskTemplateValidationErrors, [action.taskTemplateId || -1]: [] } };
        case ActionTypes.ARRANGE_FILTER_UPDATED:
            return { ...state, currentArrangeFilter: action.filter };
        case ActionTypes.ARRANGE_CLEAR_TASK_TEMPLATES:
            return { ...state, arrangeTaskTemplates: [] };
        case ActionTypes.ARRANGE_RETRIEVING_TASK_TEMPLATES:
            return { ...state, isArrangeLoading: true };
        case ActionTypes.ARRANGE_RETRIEVED_TASK_TEMPLATES:
            return { ...state, arrangeTaskTemplates: action.arrangeTaskTemplates, isArrangeLoading: false };
        case ActionTypes.TASK_TEMPLATE_TAGS_RETRIEVED:
            return { ...state, taskTemplateTags: action.data };
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/Store/TaskTemplates/TaskTemplateReducer.ts